import { TitleAndSubtitleDisplay } from '@/atoms/TitleAndSubtitleDisplay'
import { findTitleProjectSlug, formatTitleLikeLandscapeImagePath, formatWatchPath } from '@/services/ContentCatalog'
import { CatalogTitleForMap, LinkViewModel, LinksViewProps } from '@/services/RenderService'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { logger } from '@/utils/logging'
import { LandscapeGrid } from './LandscapeGrid'
import { LargeLandscapeLink } from './LargeLandscapeLink'

export function LargeLandscapeGrid({
  imageWidth = 490,
  imageHeight = 294,
  id,
  links,
  showTitleDescription,
  className,
}: LinksViewProps) {
  return (
    <LandscapeGrid className={className} id={id} data-testid={`large-landscape-grid-${id}`}>
      {links.map((link) => (
        <div className="w-fit max-w-full" key={link.name}>
          <LargeLandscapeLink link={link} imageHeight={imageHeight} imageWidth={imageWidth} />
          {showTitleDescription && (
            <div style={{ maxWidth: `${imageWidth}px` }}>
              <TitleAndSubtitleDisplay className="my-4 w-full" title={link.name} subtitle={link.label} clampSubtitle />
            </div>
          )}
        </div>
      ))}
    </LandscapeGrid>
  )
}

LargeLandscapeGrid.mapTitle = mapTitleToLink

export function mapTitleToLink(title: CatalogTitleForMap): LinkViewModel | undefined {
  const path = formatTitleLikeLandscapeImagePath(title)
  const imageUrl = path && getCloudinaryImageUrl({ path, width: 441, height: 294 })
  const linkUrl = formatWatchPath(title)

  if (!imageUrl || !linkUrl) {
    logger().error(
      `A link view model cannot be created for this title because one or both of imageUrl and linkUrl could not be generated.`,
      { component: LargeLandscapeGrid.name, title, imageUrl, linkUrl },
    )
    return
  }

  return {
    name: title.title,
    alt: title.title,
    label: title.description.short,
    imageUrl,
    linkUrl,
    track: {
      eventName: 'Project Tile Clicked',
      payload: {
        name: title.title,
        slug: findTitleProjectSlug(title),
        label: title.description.short,
        tileType: 'large_landscape_grid',
        imageUrl,
        linkUrl,
      },
    },
  }
}
